<template>
    <v-form ref="form">
        <div class="d-flex">
            <div class="mr-4 flex-grow-1">
                <v-combobox
                    :placeholder="placeholder"
                    v-bind:label="label"
                    :class="{
                        select: true,
                        'input-cinza': true,
                        active: menu1,
                    }"
                    v-bind:required="required"
                    v-bind:disabled="disabled"
                    :menu-props="menuProps"
                    v-model="cmpValue"
                    outlined
                    validate-on-blur
                    dense
                    multiple
                    deletable-chips
                    :delimiters="[',']"
                    small-chips
                    @change="delimit"
                    :rules="regras"
                >
                    <template v-slot:selection="{ item, parent }">
                        <v-chip
                            small
                            close
                            :color="ehInvalido(item) ? 'error' : undefined"
                            :dark="ehInvalido(item)"
                            @click:close="parent.selectItem(item)"
                        >
                            {{ item }}
                        </v-chip>
                    </template>
                </v-combobox>
            </div>
            <div class="flex-shrink-0">
                <v-btn
                    color="primary"
                    class="new-button w-100"
                    @click="abrirImportacao"
                >
                    <v-icon left>mdi-plus</v-icon>
                    Importar SKUs
                </v-btn>
            </div>
        </div>
        <v-dialog
            content-class="br-15"
            scrollable
            v-model="dialogoSku"
            width="600"
        >
            <v-card>
                <v-toolbar
                    elevation="0"
                    dark
                    class="primary-degrade white--text fix-flex"
                >
                    <v-toolbar-title>Importação de SKUs </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        @click="dialogoSku = false"
                    >
                        <v-icon size="20px" color="primary">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-5">
                    Selecione o arquivo para importação. Apenas a coluna SKU
                    será importada.
                    <v-file-input
                        accept=".csv"
                        label="Arquivo"
                        dense
                        v-model="arquivoSku"
                        outlined
                        class="mt-5 input-cinza"
                    ></v-file-input>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        class="new-button mr-3 px-4 mb-4"
                        @click="processaCSV"
                    >
                        <v-icon class="mr-3">mdi-check-circle</v-icon>
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-form>
</template>
 
 <script>
export default {
    name: 'SKUInput',
    model: { prop: 'value', event: 'input' },

    props: [
        'value',
        'rules',
        'min',
        'max',
        'placeholder',
        'label',
        'required',
        'disabled',
        'change',
        'prepend-icon',
        'firstDayOfWeek',
        'produtosServidor',
        'checkProduto',
        /// SKUs a marcar em vermelho, com a mensagem abaixo do campo. Opcional:
        /// quem não passar mantém o comportamento antigo.
        'skusInvalidos',
        'mensagemInvalidos',
    ],
    data() {
        return {
            mes: null,
            menu1: false,
            dialogoSku: false,
            arquivoSku: false,

            menuProps: {
                bottom: true,
                offsetY: true,
                contentClass: 'select-outline',
                transition: 'slide-y-transition',
            },
            skuRegra (value)  {
                if(!value) {
                    return 'O sku é obrigatório'
                }
                // console.log('O sku é obrigatório')
                // if (this.required) {
                    console.log('testando...sku',value.length)
                    if (value instanceof Array && value.length == 0) {
                        return 'O sku é obrigatório';
                    }
                    return !!value || 'O sku é obrigatório';
                // } 
                // return true
            },
        }
    },
    requerido() {
        return this.required
    },
    computed: {
        cmpValue: {
            get: function () {
                return this.value
            },
            set: function (newValue) {
                this.$emit('input', newValue)
            },
        },
        listaInvalidos() {
            return (this.skusInvalidos || []).map((sku) => String(sku))
        },
        regras() {
            const regras = []

            if (this.required) regras.push(this.skuRegra)

            /// Erro de duplicidade entra como regra do próprio input: assim o
            /// Vuetify já exibe a mensagem no helper e marca o campo.
            regras.push(
                () =>
                    this.listaInvalidos.length === 0 ||
                    this.mensagemInvalidos ||
                    `SKU em duplicidade: ${this.listaInvalidos.join(', ')}`
            )

            return regras
        },
    },
    watch: {
        /// Enquanto o campo não é tocado o Vuetify não reavalia as regras, então
        /// a mensagem de duplicidade só apareceria no próximo blur.
        skusInvalidos() {
            this.$nextTick(() => this.$refs.form && this.$refs.form.validate())
        },
    },
    methods: {
        ehInvalido(sku) {
            return this.listaInvalidos.includes(String(sku))
        },
        desvalidar() {
            this.$refs.form.resetValidation()
        },
        validar() {
            // console.log('passou aqui',this.required)
            return this.$refs.form.validate() 
        },
        abrirImportacao() {
            this.arquivoSku = null
            this.dialogoSku = true
        },
        async processaCSV() {
            const parseCsv = async (csv) => {
                return new Promise((resolve) => {
                    this.$papa.parse(csv, {
                        delimiter: ';',
                        header: true,
                        dynamicTyping: true,
                        skipEmptyLines: true,
                        complete: function (results) {
                            resolve(results)
                        },
                    })
                })
            }

            var csv = await parseCsv(this.arquivoSku)

            if (csv.errors.length > 0) {
                this.$dialog.notify.error('Erro ao importar arquivo', {
                    position: 'top-right',
                    timeout: 5000,
                })
                return
            }
            if (!csv.data[0].sku) {
                this.$dialog.notify.error('Coluna SKU não encontrada', {
                    position: 'top-right',
                    timeout: 5000,
                })
                return
            }
            this.cmpValue = this.normalizarSkus(csv.data.map((e) => e.sku))
            this.dialogoSku = false
        },
        /// Quebra os valores informados, mantém apenas códigos numéricos e,
        /// quando checkProduto está ativo, só os SKUs do fornecedor selecionado
        normalizarSkus(lista) {
            const tokens = lista.reduce(
                (acumulado, item) => [
                    ...acumulado,
                    ...String(item).split(/[\s,;]+/),
                ],
                []
            )
            const codigos = [...new Set(tokens)].filter((sku) =>
                /^\d+$/.test(sku)
            )

            if (!this.checkProduto) return codigos

            const produtos = this.produtosServidor || []
            return codigos.filter((sku) =>
                produtos.some((produto) => produto.codigo == sku)
            )
        },
        delimit(v) {
            this.cmpValue = this.normalizarSkus(v)
        },
    },
}
</script>
 
 <style>
.input-cinza.active .v-input__slot {
    border-bottom: none;
}

.input-cinza.active fieldset legend {
    width: 0 !important;
}

.input-mes .v-date-picker-header__value button {
    font-weight: 500;
    color: var(--v-primary-base) !important;
}

.input-mes,
.input-mes .v-picker__body {
    width: 100% !important;
}
.input-mes .v-btn__content {
    text-transform: capitalize;
}
.input-mes input {
    text-transform: uppercase !important;
}
.input-mes .theme--light.v-date-picker-table th {
    color: #ccc !important;
}
.input-mes .v-date-picker-table--date td {
    color: #ccc !important;
    padding: 0 !important;
}
</style>